import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import CapacityDataProvider from 'scaleflow/controllers/planning/dashboard/capacity/capacity-data-provider';

export default class PlanningDashboardCapacityTeamsController extends CapacityDataProvider {
  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'productManagers',
    'teams',
    'columns',
  ];

  @tracked initiativeFormIsVisible = false;

  @tracked grouping = 'teams';
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked product_managers = [];
  @tracked teams = [];
  @tracked columns = [
    'Progress',
    'Owner',
    'Effort',
    'Uncertainty',
    'Team Effort',
    'Starting week',
    'Duration',
  ];

  @action
  toggleInitiativeForm(val) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  setRoadmapOnInitiative(initiative) {
    const roadmap = this.store.peekRecord('roadmap', this.roadmap_id);
    initiative.roadmaps = [roadmap];
    initiative.save();
  }
}
